import { useState } from 'react'
import Image from 'next/image'
import { AnimatePresence, motion } from 'motion/react'

export const ResponsiveImage = ({
  src,
  alt = '',
  className = '',
  fit = 'cover',
  position = 'center',
  sizes = '100vw',
  priority = false,
  ...rest
}) => {
  const [loaded, setLoaded] = useState(false)
  if (!src) return null
  return (
    <>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: loaded ? 1 : 0 }}
        className={`relative h-full w-full overflow-hidden ${className}`}
        transition={{
          duration: 0.25,
          ease: 'linear',
        }}
      >
        <Image
          src={src}
          alt={alt}
          fill
          style={{ objectFit: fit, objectPosition: position } as any}
          loading={priority ? 'eager' : 'lazy'}
          priority={priority}
          sizes={sizes}
          onLoad={() => {
            setLoaded(true)
          }}
          {...rest}
        />
      </motion.div>
      <AnimatePresence>
        {!loaded ? (
          <motion.div
            className="absolute left-0 top-0 h-full w-full"
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              duration: 0.25,
              ease: 'linear',
            }}
          >
            <Image
              src={`${src}&width=100&q=10`}
              alt={alt}
              fill
              style={{ objectFit: fit, objectPosition: position } as any}
              sizes={sizes}
              {...rest}
              className="z-[9] blur-sm md:blur-md"
            />
          </motion.div>
        ) : null}
      </AnimatePresence>
    </>
  )
}
